import { useTranslation } from 'react-i18next';
import { useRouteMatch } from 'react-router-dom';
import { SmartLink } from '@shared/lib/routing';
import { Subtitle } from '@shared/ui/titles';
import { useResetCartModal } from '@features/cart-reset';

export function CartHeader() {
  const modal = useResetCartModal();
  const { isExact } = useRouteMatch();
  const { t } = useTranslation();

  const linkStyles =
    'uppercase text-(--primary-main) text-xs border-b-1 border-dashed hover:border-transparent xl:text-(--verydarkgray) xl:text-sm';

  const act = isExact ? (
    <button type="button" className={linkStyles} onClick={() => modal.show()}>
      {t('BlockProducts.resetCart')}
    </button>
  ) : (
    <SmartLink className={linkStyles} href="/cart">
      {t('BlockProducts.editCart')}
    </SmartLink>
  );
  return (
    <header className="flex items-center justify-between gap-2">
      <Subtitle>{t('NewCart.yourOrder')}</Subtitle>
      {act}
    </header>
  );
}
